/* eslint-disable require-jsdoc */
import {renderPopUpMap} from '../map/widgetMap';
import GoogleMapsApi from '../map/GoogleMapsApi';
import { debug } from '../../../../config';

function initMap(popUp, popUpData) {
  if (document.querySelector(`.hearby-map-popup-${popUp.widgetID}`)) {
    const gMapApi = new GoogleMapsApi(popUp.gMapApiKey);
    gMapApi.load().then(() => {
      const mapEl = document.querySelector(
          `.hearby-map-popup-${popUp.widgetID}`,
      );
      mapEl.style.height = '300px';
      debug && console.log('init-map popup', popUp);
      // eslint-disable-next-line no-invalid-this
      debug && console.log('this in initMap', this);
      renderPopUpMap(popUp, mapEl, popUpData);
    });
  }
}
export {initMap};
